import { Factory } from './_factory';
import { Role } from '@app/enums/_index';
import { Roles } from '@app/models/_index';

/**
 * Create Role Factory used by application
 * Creates instances of Roles
 */
export class RoleFactory implements Factory<Roles> {
  roles: Roles[] = [];

  /**
   * Call and build static learning types array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static learning types array to be used to determine the Course learning type
   * Used to show and filter tooltips for a given course detail
   */
  build(): void {
    this.roles.push(
      new Roles(
        Role.ADMINISTRATOR,
        'Daily operations, user and group administration, callflow setup, configuration changes, and usage policies',
        true
      )
    );
    this.roles.push(
      new Roles(
        Role.AGENT,
        'Customer interactions through channels such as voice, chat, SMS, email, and social media',
        true
      )
    );
    this.roles.push(
      new Roles(
        Role.BUSINESS_USER,
        'Business operations and collaborating through chat, video conference, calls, and document sharing',
        true
      )
    );
    this.roles.push(
      new Roles(
        Role.DEVELOPER,
        'Creating applications connected to Genesys resources through Genesys APIs, client libraries, and JavaScript APIs',
        true
      )
    );
    this.roles.push(
      new Roles(
        Role.LEARNING_PATHS_BY_ROLE,
        'Personalized and visual learning paths designed for Genesys Cloud users',
        true
      )
    );
    this.roles.push(new Roles(Role.IT, 'Explore IT recommended courses', false));
  }

  /**
   * Return immutable or copy of Role collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): Roles[] {
    if (this.roles && this.roles.length === 0) {
      this.build();
    }
    return this.roles.slice();
  }
}
